module.exports = {"513427100":"披砂镇","513427101":"松新镇","513427102":"竹寿镇","513427103":"华弹镇","513427104":"白鹤滩镇","513427105":"葫芦口镇","513427106":"西瑶镇","513427200":"景星乡","513427201":"俱乐乡","513427202":"新村乡","513427203":"幸福乡","513427204":"海子乡","513427205":"六铁乡","513427206":"新建乡","513427207":"稻谷乡","513427208":"新华乡","513427209":"石梨乡","513427210":"松林乡","513427211":"杉树乡","513427212":"梁子乡","513427213":"大同乡","513427215":"红星乡","513427216":"骑骡沟乡","513427217":"倮格乡","513427218":"跑马乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513427.json
// module id = 2250
// module chunks = 0